var map = {
	"./background/escudo.png": 97936,
	"./background/foto-estadio.jpg": 67853,
	"./background/header.png": 63076,
	"./background/home.jpg": 36170,
	"./background/jogos.jpg": 47977,
	"./background/section.jpg": 48218,
	"./background/section.png": 88894,
	"./favicon.ico": 42354,
	"./icon-loja.png": 17840,
	"./icon-oficial.png": 53433,
	"./icon-social/facebook_icon.png": 70412,
	"./icon-social/facebook_icon.svg": 66843,
	"./icon-social/instagram_icon.png": 14774,
	"./icon-social/instagram_icon.svg": 51617,
	"./icon-social/tiktok_icon.png": 93934,
	"./icon-social/tiktok_icon.svg": 1065,
	"./icon-social/x_icon.png": 98970,
	"./icon-social/x_icon.svg": 56149,
	"./icon-social/youtube_icon.png": 27191,
	"./icon-social/youtube_icon.svg": 40088,
	"./landing-page/icons/bandeira.png": 8955,
	"./landing-page/icons/bebida.png": 26338,
	"./landing-page/icons/carteirinha.png": 33957,
	"./landing-page/icons/cativa.png": 14605,
	"./landing-page/icons/celular.png": 82893,
	"./landing-page/icons/desconto.png": 99504,
	"./landing-page/icons/estadio.png": 27532,
	"./landing-page/icons/estrela.png": 99473,
	"./landing-page/icons/fogos.png": 74033,
	"./landing-page/icons/ingresso.png": 49791,
	"./landing-page/icons/like.png": 64006,
	"./landing-page/icons/mao.png": 87610,
	"./landing-page/icons/mensal.png": 81475,
	"./landing-page/icons/parceiro.png": 12664,
	"./landing-page/icons/star.png": 18591,
	"./landing-page/icons/switch.png": 54043,
	"./landing-page/icons/televisao.png": 36709,
	"./landing-page/icons/torcida.png": 2565,
	"./landing-page/icons/trofeu.png": 89288,
	"./landing-page/icons/trombone.png": 75295,
	"./landing-page/icons/tv.png": 68501,
	"./leao.svg": 84392,
	"./logo-rodape.svg": 30792,
	"./logo-site.png": 88867,
	"./personalize/cativa.jpg": 29405,
	"./personalize/icon-cativa.png": 79841,
	"./personalize/icon-kids.png": 84572,
	"./personalize/icon-pcd.png": 37982,
	"./personalize/kids.jpg": 75988,
	"./personalize/pcd.jpg": 47934,
	"./planos/background/retangulo/planos.png": 78758,
	"./planos/logo-socio-sou-mais-vitoria.svg": 43070,
	"./planos/socio.svg": 30354,
	"./planos/sou-colossal-feminino-white.svg": 88433,
	"./planos/sou-colossal-jovem-white.svg": 6697,
	"./planos/sou-colossal-white.svg": 83313,
	"./planos/sou-leao-da-barra-jovem-white.svg": 61295,
	"./planos/sou-leao-da-barra-white.svg": 11083,
	"./planos/sou-leaozinho-white.svg": 74976,
	"./planos/sou-leoa-da-barra-white.svg": 85163,
	"./planos/sou-sem-fronteiras-white.svg": 48140,
	"./planos/sou-vermelho-e-preto-white.svg": 60712,
	"./produtos/pcd.svg": 7147,
	"./produtos/plano.svg": 23694,
	"./vantagens/circle-exclamation.svg": 61647,
	"./vantagens/circle-info.svg": 6416,
	"./vantagens/clube-leao-de-vantagens.png": 95299,
	"./vantagens/codigo-background.png": 28164,
	"./vantagens/codigo.svg": 31850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87933;